// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de los valores del tragamonedas
 * @param {*} scene 
 */
export function cargaAssetsValoresTragamonedas(scene) {

  for (let i = 1; i <= 11; i++) {
    scene.load.image(
      `valor${i}Estatico`,
      `${ROUTES.rutaTragamonedasValoresTragamonedas}/valor${i}EstaticoResized.png`
    );
  
    scene.load.spritesheet(
      `valor${i}Animado`,
      `${ROUTES.rutaTragamonedasValoresTragamonedas}/valor${i}AnimadoResized-Sheet.png`,
      {
        frameWidth: 90,
        frameHeight: 60,
      }
    );
  }

  /*
  scene.load.image(
    "valor1Estatico",
    ROUTES.rutaTragamonedasValoresTragamonedas + "/valor1EstaticoResized.png"
  );

  scene.load.spritesheet(
    "valor1Animado",
    ROUTES.rutaTragamonedasValoresTragamonedas + "/palanca1ovimientoResized-Sheet.png",
    {
      frameWidth: 90,
      frameHeight: 60,
    }
  );
  */

}
